import './Loading.css'

const Loading =()=>{
    return(
        <div className="Loading">
            <p>Loading...</p>
        </div>
    )
}
export default Loading